// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3o0am","sendOtp":"AuthorizeToLogin_sendOtp__3KX-U"};